import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';

import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import {NgxImageCompressService} from 'ngx-image-compress';


/**
 * Providers
 */
import { Api } from '../providers/api/api';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Camera } from '@ionic-native/camera';
import { Push } from '@ionic-native/push';
import { Notifications } from '../providers/notifications/notifications';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
//import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';



/**
 * Data Access Objects
 */
import { UsuarioDAO } from '../daos/usuario-dao';
import { LoteDAO } from '../daos/lote-dao';
import { GrupoDAO } from '../daos/grupo-dao';



import { MyApp } from './app.component';

/**
 * Pipes
 */
import { MomentPipe } from '../pipes/moment-pipe';

/**
 * Components
 */
import { MenuComponent } from '../components/menu/menu';
import { ReactionComponent } from '../components/reaction/reaction';
import { ResumaoComponent } from '../components/resumao/resumao';

/**
 * Pages
 */
import { LoginPage } from '../pages/login/login';
import { UsuarioNovoPage } from '../pages/usuario-novo/usuario-novo';
import { HomePage } from '../pages/home/home';
import { ReceberLoteHomePage } from '../pages/receber-lote-home/receber-lote-home';      
import { ReceberLoteNovoPage } from '../pages/receber-lote-novo/receber-lote-novo';  
import { RevisarLoteHomePage } from '../pages/revisar-lote-home/revisar-lote-home';
import { RevisarLoteNovoPage } from '../pages/revisar-lote-novo/revisar-lote-novo';
import { InspecionarLoteHomePage } from '../pages/inspecionar-lote-home/inspecionar-lote-home';  
import { InspecionarLoteNovoPage } from '../pages/inspecionar-lote-novo/inspecionar-lote-novo';  
import { UsuarioHomePage } from '../pages/usuario-home/usuario-home';
import { TabelaMedidaPage } from '../pages/tabela-medida/tabela-medida';







@NgModule({
    declarations: [
        MyApp,
        MomentPipe,
        LoginPage,        
        MenuComponent,
        ReactionComponent,
        ResumaoComponent,
        HomePage,  
        ReceberLoteHomePage,
        ReceberLoteNovoPage,
        RevisarLoteHomePage,
        RevisarLoteNovoPage,
        InspecionarLoteHomePage,
        InspecionarLoteNovoPage,
        UsuarioNovoPage,
        UsuarioHomePage,
        TabelaMedidaPage
    ],
    imports: [
        BrowserModule,
	Ng2SearchPipeModule,
        HttpModule,
        IonicStorageModule.forRoot(),
        IonicModule.forRoot(MyApp, {
            monthNames: ['Janeiro', 'Fevereiro', 'Mar\u00e7o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthShortNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            dayNames: ['Domingo', 'Segunda-feira', 'Ter\u00e7a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'S\u00e1bado'],
            dayShortNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'S\u00e1b']
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        LoginPage,        
        MenuComponent,
        ReactionComponent,
        ResumaoComponent,
        HomePage,  
        ReceberLoteHomePage,
        ReceberLoteNovoPage,
        RevisarLoteHomePage,
        RevisarLoteNovoPage,
        InspecionarLoteHomePage,
        InspecionarLoteNovoPage,
        UsuarioNovoPage,
        UsuarioHomePage,
        TabelaMedidaPage
    ],
    providers: [
        Api,
        StatusBar,
        SplashScreen,
        Camera,
        Push,
        Notifications,
        UsuarioDAO,
        LoteDAO,
        GrupoDAO, [NgxImageCompressService],  
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts